export default __webpack_public_path__ + "static/media/2_example.77e756c9.jpg";